import { render, staticRenderFns } from "./image-input-component.vue?vue&type=template&id=4104fcec"
import script from "./image-input-component.vue?vue&type=script&setup=true&lang=js"
export * from "./image-input-component.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports